const p = {
  large: ["100%", "900px"],
  medium: ["100%", "640px"],
  small: ["100%", "500px"]
};
export {
  p as MAX_WIDTH_MAP
};
